(() => {
  'use strict';
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-gallery-thumb]');
    if (!button) return;
    const gallery = button.closest('[data-product-gallery]');
    if (button.dataset.mediaIndex && gallery) {
      const template=[...gallery.querySelectorAll('[data-media-template]')].find(t=>t.dataset.mediaTemplate===button.dataset.mediaIndex);
      const stage=gallery.querySelector('[data-media-stage]');
      if(!template||!stage)return;
      stage.querySelectorAll('video').forEach(video=>video.pause());
      stage.replaceChildren(template.content.cloneNode(true));
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(thumb=>thumb.setAttribute('aria-pressed',String(thumb===button)));
      return;
    }
    const image = gallery?.querySelector('.native-gallery-image');
    if (!image || !button.dataset.imageSrc) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = button.dataset.imageSrc;
    image.alt = button.dataset.imageAlt || '';
    image.width = Number(button.dataset.imageWidth);
    image.height = Number(button.dataset.imageHeight);
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
      thumb.setAttribute('aria-pressed', String(thumb === button));
    });
  });
})();
